(() => {
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

    const sectionId = ("YurchakFeatured-" + __shopifySectionId + "");

    const rootUrl = () => {
      return window.Shopify?.routes?.root || '/';
    };

    const requestJSON = async (path, options = {}) => {
      const response = await fetch(`${rootUrl()}${path}`, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          ...(options.headers || {})
        }
      });

      if (!response.ok) {
        let message = 'Shopify request failed';

        try {
          const error = await response.json();

          message =
            error.description ||
            error.message ||
            message;
        } catch (error) {
          /* Empty error response. */
        }

        throw new Error(message);
      }

      return response.json();
    };

    const getCart = () => requestJSON('cart.js');

    const addVariant = (variantId) => {
      return requestJSON('cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });
    };

    const removeLine = (lineKey) => {
      return requestJSON('cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });
    };

    const findCartLine = (cart, variantId) => {
      return cart.items.find((item) => {
        return Number(item.variant_id) === Number(variantId);
      });
    };

    const formatMoney = (cents) => {
      const currency =
        window.Shopify?.currency?.active || 'USD';

      const locale =
        document.documentElement.lang || 'en';

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    };

    const updateCartCounter = (cart) => {
      const count = Number(cart.item_count || 0);

      document
        .querySelectorAll(
          '.cart-count-bubble span[aria-hidden="true"], ' +
          '.cart-count-bubble span:first-child'
        )
        .forEach((element) => {
          element.textContent = count;
        });

      document
        .querySelectorAll('.cart-count-bubble')
        .forEach((bubble) => {
          bubble.classList.toggle('hidden', count === 0);
        });
    };

    let toastTimeout = null;

    const hideToast = () => {
      const toast = document.querySelector('[data-yfp-toast]');

      if (!toast) return;

      clearTimeout(toastTimeout);
      toast.classList.remove('is-visible');
    };

    const getToast = () => {
      let toast = document.querySelector('[data-yfp-toast]');

      if (toast) return toast;

      toast = document.createElement('div');
      toast.className = 'yfp-toast';
      toast.dataset.yfpToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.tabIndex = -1;

      toast.innerHTML = `
        <div class="yfp-toast__content">
          <span
            class="yfp-toast__message"
            data-yfp-toast-message
          ></span>

          <button
            class="yfp-toast__close"
            type="button"
            data-yfp-toast-close
            aria-label="Close notification"
          >
            ×
          </button>
        </div>

        <div class="yfp-toast__progress">
          <div
            class="yfp-toast__bar"
            data-yfp-toast-bar
          ></div>
        </div>
      `;

      document.body.appendChild(toast);

      toast
        .querySelector('[data-yfp-toast-close]')
        .addEventListener('click', (event) => {
          event.stopPropagation();
          hideToast();
        });

      const openCartFromToast = (event) => {
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) {
          return;
        }

        if (event.target.closest('[data-yfp-toast-close]')) {
          return;
        }

        if (toast.dataset.cartLink !== 'true') {
          return;
        }

        event.preventDefault();
        window.location.assign(`${rootUrl()}cart`);
      };

      toast.addEventListener('click', openCartFromToast);
      toast.addEventListener('keydown', openCartFromToast);

      return toast;
    };

    const showToast = (message, linkToCart = false) => {
      const toast = getToast();

      const messageElement =
        toast.querySelector('[data-yfp-toast-message]');

      const bar =
        toast.querySelector('[data-yfp-toast-bar]');

      messageElement.textContent = linkToCart ? `${message} — View cart` : message;

      toast.dataset.cartLink = linkToCart ? 'true' : 'false';
      toast.classList.toggle('is-cart-link', linkToCart);
      toast.tabIndex = linkToCart ? 0 : -1;
      toast.setAttribute('role', linkToCart ? 'link' : 'status');
      toast.setAttribute('aria-label', linkToCart ? `${message}. Open cart` : message);

      clearTimeout(toastTimeout);

      toast.classList.remove('is-visible');
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(1)';

      requestAnimationFrame(() => {
        toast.classList.add('is-visible');

        requestAnimationFrame(() => {
          bar.style.transition = 'transform 5000ms linear';
          bar.style.transform = 'scaleX(0)';
        });
      });

      toastTimeout = setTimeout(hideToast, 5000);
    };

    const initializeSection = async () => {
      const section = document.getElementById(sectionId);

      if (
        !section ||
        section.dataset.yfpInitialized === 'true'
      ) {
        return;
      }

      section.dataset.yfpInitialized = 'true';

      const tabs = Array.from(
        section.querySelectorAll('[data-yfp-tab]')
      );

      const panels = Array.from(
        section.querySelectorAll('[data-yfp-panel]')
      );

      const activateTab = (blockId) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.yfpTab === blockId;

          tab.classList.toggle('is-active', active);

          tab.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );

          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          const active =
            panel.dataset.yfpPanel === blockId;

          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activateTab(tab.dataset.yfpTab);
        });
      });

      let currentCart;

      try {
        currentCart = await getCart();
      } catch (error) {
        currentCart = {
          items: [],
          item_count: 0
        };
      }

      const cards = Array.from(
        section.querySelectorAll('[data-yfp-card]')
      );

      const syncCardButton = (card) => {
        const button =
          card.querySelector('[data-yfp-cart-button]');

        if (!button) return;

        const line = findCartLine(
          currentCart,
          button.dataset.variantId
        );

        button.classList.toggle(
          'is-in-cart',
          Boolean(line)
        );

        button.setAttribute(
          'aria-label',
          line
            ? 'Remove product from cart'
            : 'Add product to cart'
        );
      };

      cards.forEach((card) => {
        const variantData =
          card.querySelector('[data-yfp-variant-data]');

        const cartButton =
          card.querySelector('[data-yfp-cart-button]');

        const hasCustomImage =
          card.dataset.hasCustomImage === 'true';

        if (!variantData || !cartButton) return;

        let variants = [];

        try {
          variants = JSON.parse(variantData.textContent);
        } catch (error) {
          console.error('YURCHAK variant JSON error', error);
          return;
        }

        const colorIndex = Number(card.dataset.colorIndex);
        const sizeIndex = Number(card.dataset.sizeIndex);

        let selectedColor = null;
        let selectedSize = null;

        let selectedVariant = variants.find((variant) => {
          return (
            Number(variant.id) ===
            Number(card.dataset.selectedVariantId)
          );
        });

        if (!selectedVariant) {
          selectedVariant =
            variants.find((variant) => variant.available) ||
            variants[0];
        }

        if (selectedVariant && colorIndex >= 0) {
          selectedColor =
            selectedVariant.options[colorIndex];
        }

        const slides = Array.from(
          card.querySelectorAll('[data-yfp-slide]')
        );

        const imageCounter =
          card.querySelector('[data-yfp-current-image]');

        let currentSlide = slides.findIndex((slide) => {
          return slide.classList.contains('is-active');
        });

        if (currentSlide < 0) {
          currentSlide = 0;

          if (slides[0]) {
            slides[0].classList.add('is-active');
            slides[0].setAttribute('aria-hidden', 'false');
          }
        }

        let autoplayInterval = null;

        const showSlide = (index) => {
          if (!slides.length) return;

          let resolvedIndex = index;

          if (resolvedIndex < 0) {
            resolvedIndex = slides.length - 1;
          }

          if (resolvedIndex >= slides.length) {
            resolvedIndex = 0;
          }

          currentSlide = resolvedIndex;

          slides.forEach((slide, slideIndex) => {
            const active =
              slideIndex === resolvedIndex;

            slide.classList.toggle('is-active', active);

            slide.setAttribute(
              'aria-hidden',
              active ? 'false' : 'true'
            );
          });

          if (imageCounter) {
            imageCounter.textContent =
              resolvedIndex + 1;
          }
        };

        const startAutoplay = () => {
          clearInterval(autoplayInterval);

          if (
            window.matchMedia('(max-width: 749px)').matches &&
            slides.length > 1
          ) {
            autoplayInterval = setInterval(() => {
              showSlide(currentSlide + 1);
            }, 4000);
          }
        };

        const showVariantImage = (variant, swatch = null) => {
          if (!variant) return;

          const mediaId =
            variant.featured_media_id ||
            swatch?.dataset.previewMediaId;

          if (mediaId) {
            const targetIndex = slides.findIndex((slide) => {
              return (
                String(slide.dataset.mediaId) ===
                String(mediaId)
              );
            });

            if (targetIndex >= 0) {
              showSlide(targetIndex);
              startAutoplay();
              return;
            }
          }

          const imageUrl =
            variant.featured_image_url ||
            swatch?.dataset.previewImage;

          if (!imageUrl || !slides.length) return;

          const activeSlide =
            slides[currentSlide] || slides[0];

          const image =
            activeSlide.querySelector('.yfp-card__image');

          if (image) {
            image.src = imageUrl;
            image.srcset = '';
          }

          showSlide(currentSlide);
          startAutoplay();
        };

        card
          .querySelector('[data-yfp-previous]')
          ?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            showSlide(currentSlide - 1);
            startAutoplay();
          });

        card
          .querySelector('[data-yfp-next]')
          ?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            showSlide(currentSlide + 1);
            startAutoplay();
          });

        const gallery =
          card.querySelector('[data-yfp-gallery]');

        if (gallery) {
          let touchStartX = null;
          let touchStartY = null;

          gallery.addEventListener(
            'touchstart',
            (event) => {
              const touch = event.touches[0];

              touchStartX = touch.clientX;
              touchStartY = touch.clientY;

              clearInterval(autoplayInterval);
            },
            { passive: true }
          );

          gallery.addEventListener(
            'touchend',
            (event) => {
              if (
                touchStartX === null ||
                touchStartY === null
              ) {
                return;
              }

              const touch = event.changedTouches[0];

              const differenceX =
                touch.clientX - touchStartX;

              const differenceY =
                touch.clientY - touchStartY;

              touchStartX = null;
              touchStartY = null;

              if (
                Math.abs(differenceX) > 40 &&
                Math.abs(differenceX) >
                  Math.abs(differenceY)
              ) {
                if (differenceX < 0) {
                  showSlide(currentSlide + 1);
                } else {
                  showSlide(currentSlide - 1);
                }
              }

              startAutoplay();
            },
            { passive: true }
          );
        }

        const getMatchingVariant = ({
          color = selectedColor,
          size = selectedSize,
          availableOnly = false
        } = {}) => {
          return variants.find((variant) => {
            if (availableOnly && !variant.available) {
              return false;
            }

            if (
              colorIndex >= 0 &&
              color !== null &&
              variant.options[colorIndex] !== color
            ) {
              return false;
            }

            if (
              sizeIndex >= 0 &&
              size !== null &&
              variant.options[sizeIndex] !== size
            ) {
              return false;
            }

            return true;
          });
        };

        const updateLinks = (variant) => {
          if (!variant) return;

          const url =
            `${card.dataset.productUrl}?variant=${variant.id}`;

          card
            .querySelectorAll('[data-yfp-product-link]')
            .forEach((link) => {
              link.href = url;
            });
        };

        const updatePrice = (variant) => {
          if (!variant) return;

          const price =
            card.querySelector('[data-yfp-current-price]');

          const comparePrice =
            card.querySelector('[data-yfp-compare-price]');

          const priceWrapper =
            card.querySelector('[data-yfp-price]');

          const onSale =
            Number(variant.compare_at_price) >
            Number(variant.price);

          price.textContent = formatMoney(variant.price);

          price.classList.toggle(
            'yfp-card__sale-price',
            onSale
          );

          price.classList.toggle(
            'yfp-card__regular-price',
            !onSale
          );

          priceWrapper?.classList.toggle(
            'is-sale',
            onSale
          );

          if (onSale) {
            comparePrice.textContent =
              formatMoney(variant.compare_at_price);

            comparePrice.hidden = false;
          } else {
            comparePrice.textContent = '';
            comparePrice.hidden = true;
          }
        };

        const sizePopover =
          card.querySelector('[data-yfp-size-popover]');

        const sizeButtons = Array.from(
          card.querySelectorAll('[data-yfp-size]')
        );

        const confirmSize =
          card.querySelector('[data-yfp-confirm-size]');

        const updateSizeAvailability = () => {
          if (sizeIndex < 0) return;

          sizeButtons.forEach((button) => {
            const availableVariant =
              getMatchingVariant({
                size: button.dataset.sizeValue,
                availableOnly: true
              });

            button.disabled = !availableVariant;

            if (
              !availableVariant &&
              button.classList.contains('is-active')
            ) {
              button.classList.remove('is-active');
              selectedSize = null;
            }
          });

          if (confirmSize) {
            confirmSize.disabled = !selectedSize;
          }
        };

        const setVariant = (variant, swatch = null, updateImage = true) => {
          if (!variant) return;

          selectedVariant = variant;

          card.dataset.selectedVariantId =
            variant.id;

          cartButton.dataset.variantId =
            variant.id;

          cartButton.disabled =
            !variant.available;

          updateLinks(variant);
          updatePrice(variant);

          if (updateImage) {
            showVariantImage(variant, swatch);
          }

          syncCardButton(card);
        };

        card
          .querySelectorAll('[data-yfp-color]')
          .forEach((swatch) => {
            swatch.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();

              selectedColor =
                swatch.dataset.colorValue;

              selectedSize = null;

              card
                .querySelectorAll('[data-yfp-color]')
                .forEach((item) => {
                  item.classList.toggle(
                    'is-active',
                    item === swatch
                  );
                });

              sizeButtons.forEach((button) => {
                button.classList.remove('is-active');
              });

              updateSizeAvailability();

              const variant =
                getMatchingVariant({
                  availableOnly: true
                }) ||
                getMatchingVariant();

              setVariant(variant, swatch, !hasCustomImage);
            });
          });

        sizeButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (button.disabled) return;

            selectedSize =
              button.dataset.sizeValue;

            sizeButtons.forEach((item) => {
              item.classList.toggle(
                'is-active',
                item === button
              );
            });

            const variant =
              getMatchingVariant({
                availableOnly: true
              });

            if (variant) {
              setVariant(variant, null, !hasCustomImage);
            }

            if (confirmSize) {
              confirmSize.disabled = !variant;
            }
          });
        });

        const closeSizePopover = () => {
          if (sizePopover) {
            sizePopover.hidden = true;
          }
        };

        card
          .querySelector('[data-yfp-size-close]')
          ?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            closeSizePopover();
          });

        const toggleCart = async () => {
          if (!selectedVariant) return;

          cartButton.classList.add('is-loading');

          try {
            currentCart = await getCart();

            const existingLine =
              findCartLine(
                currentCart,
                selectedVariant.id
              );

            if (existingLine) {
              currentCart =
                await removeLine(existingLine.key);

              showToast(
                `${card.dataset.productTitle} removed from cart`
              );
            } else {
              await addVariant(selectedVariant.id);

              currentCart = await getCart();

              showToast(
                `${card.dataset.productTitle} added to cart`,
                true
              );
            }

            updateCartCounter(currentCart);
            cards.forEach(syncCardButton);
            closeSizePopover();
          } catch (error) {
            console.error(error);

            showToast(
              error.message ||
                'Something went wrong. Please try again.'
            );
          } finally {
            cartButton.classList.remove('is-loading');
          }
        };

        cartButton.addEventListener(
          'click',
          async (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (
              sizeIndex >= 0 &&
              !selectedSize
            ) {
              updateSizeAvailability();

              if (sizePopover) {
                sizePopover.hidden =
                  !sizePopover.hidden;
              }

              return;
            }

            await toggleCart();
          }
        );

        confirmSize?.addEventListener(
          'click',
          async (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (!selectedSize) return;

            await toggleCart();
          }
        );

        document.addEventListener('click', (event) => {
          const cartArea =
            card.querySelector('.yfp-card__cart-area');

          if (
            sizePopover &&
            !sizePopover.hidden &&
            cartArea &&
            !cartArea.contains(event.target)
          ) {
            closeSizePopover();
          }
        });

        updateSizeAvailability();
        setVariant(selectedVariant, null, !hasCustomImage);
        startAutoplay();
      });

      cards.forEach(syncCardButton);
    };

    initializeSection();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        const loadedSection =
          event.target.querySelector?.(`#${sectionId}`);

        if (!loadedSection) return;

        loadedSection.dataset.yfpInitialized = 'false';

        initializeSection();
      }
    );
  })();
